import { Users, PhoneOutgoing, PhoneCall, Trophy, Repeat, Zap } from "lucide-react";
import { fmtMoney } from "@/lib/constants";

export default function StatCards({ stats }) {
  if (!stats) return null;
  const r = stats.rates || {};
  const cards = [
    { id: "total-leads", label: "Total Leads", value: stats.total_leads, sub: "in pipeline", icon: Users, color: "#818CF8" },
    { id: "calls-scheduled", label: "Calls Scheduled", value: stats.calls_scheduled, sub: `${r.scheduled_rate}% of leads`, icon: PhoneOutgoing, color: "#67E8F9" },
    { id: "calls-completed", label: "Calls Completed", value: stats.calls_completed, sub: `${r.completed_rate}% of scheduled`, icon: PhoneCall, color: "#A78BFA" },
    { id: "closed-won", label: "Closed Won", value: stats.closed_won, sub: `${r.close_rate}% of leads`, icon: Trophy, color: "#6EE7B7" },
    { id: "closed-mrr", label: "Closed MRR", value: fmtMoney(stats.closed_mrr), sub: "monthly recurring", icon: Repeat, color: "#6EE7B7", mono: true },
    { id: "self-booked", label: "Self-Booked", value: stats.self_booked, sub: "booked without outreach", icon: Zap, color: "#FCD34D" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      {cards.map((c, i) => {
        const Icon = c.icon;
        return (
          <div
            key={c.id}
            data-testid={`stat-card-${c.id}`}
            className="gos-card p-4 fade-up hover:border-white/20 transition-colors"
            style={{ animationDelay: `${i * 50}ms` }}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="eyebrow">{c.label}</span>
              <Icon className="w-4 h-4" style={{ color: c.color }} />
            </div>
            <div className="font-mono-g text-2xl sm:text-[26px] font-bold text-white tracking-tight" style={c.mono ? { color: c.color } : {}}>
              {c.value}
            </div>
            <div className="text-[11px] text-slate-500 mt-1">{c.sub}</div>
          </div>
        );
      })}
    </div>
  );
}
